import axios from 'axios'

axios.defaults.baseURL = 'https://api.diten.mx/api/';

axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token');